import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { WINDOW_PROVIDERS } from 'projects/qo-commons/src/services/window.service/window.service';
import { provideHttpClient, withInterceptorsFromDi, withFetch } from '@angular/common/http';
import { MetaTagsService } from 'projects/qo-commons/src/services/meta-tags/meta-tags.service';
import { QomePublicApiModule } from 'projects/qome-public-api/src/api.module';

export const appConfig: ApplicationConfig = {
  providers: [
    WINDOW_PROVIDERS,
    MetaTagsService, 
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: "enabled",
      })
    ),
    provideClientHydration(withEventReplay()),
    importProvidersFrom(QomePublicApiModule.forRoot())
  ]
};
